export function logoHiding() {
    var siteLogo = document.querySelector('.site-logo');
    var siteLogoHeight = siteLogo.querySelector("img").offsetHeight;
    let lastScrollY = window.scrollY;
    let isAnimating = false;

    // Set the initial height to ensure smooth transitions
    siteLogo.style.height = `${siteLogoHeight}px`;


    function handleScroll() {

       //if (isAnimating) return;

        const currentScrollY = window.scrollY;
        if (currentScrollY > 100) {
            siteLogo.style.height = `${siteLogoHeight}px`;
            siteLogo.style.opacity = '1';
        } else {
            siteLogo.style.opacity = '0';
            siteLogo.style.height = '0';
   
        }

        // if (currentScrollY === 0) {
        //     // At the very top of the page, ensure the logo is visible
        //     siteLogo.style.height = `${siteLogoHeight}px`;
        //     siteLogo.style.opacity = '1';
        // } else if (currentScrollY > lastScrollY) {
        //     // Scrolling down, hide the logo
        //     siteLogo.style.opacity = '0';
        //     isAnimating = true;
        //     setTimeout(() => {
        //         siteLogo.style.height = '0';
        //         isAnimating = false;
        //     }, 300); // Delay to match the opacity transition
        // } else {
        //     // Scrolling up, show the logo
        //     siteLogo.style.height = `${siteLogoHeight}px`;
        //     siteLogo.style.opacity = '1';
        // }

        lastScrollY = currentScrollY;

    }
    handleScroll();
    window.addEventListener('resize', handleScroll);
    window.addEventListener('scroll', handleScroll);
}